<template>
  <v-layout class="inner-pages" column :style="{height: $store.getters.getAppHeight + 'px'}">
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <v-flex class="pt-0">
        <h2 class="page-head" id="link-index"><span class="page-heading">Privacy Policy</span></h2>


        <div class="block ">
          <div >

            <div class="block-header" id="term1">
              <h2><span class="title">Overview</span></h2>
            </div>
            <p>Your privacy is important to us. We have these goals:</p>
            <ul>
              <li>We don’t ask you for personal information unless needed to meet your expected objective.</li>
              <li>We don’t share your personal information with anyone except to comply with the law, develop our products, or protect our rights.</li>
              <li>We don’t store personal information on our servers unless required for the on-going operation of one of our services.</li>
            </ul>
            <p>In the use of our sites and applications, we aim to protect your privacy as a certificate program participant, a business unit manager, or a program author-editor.</p>
            <p>Below is more detail on how we incorporate these goals.</p>


            <div class="block-header" id="term2">
              <h2><span class="title">Website Visitors</span></h2>
            </div>
            <p>Like other website operators, Cogneti, LLC (Cogneti) collects two kinds of information.</p>
            <h3>Personally Identifiable Information Data (PIID)</h3>
            <p>Allows Cogneti users to be personally identified or authenticated. This includes email, telephone numbers, account names, credit card numbers, and locations. In the case of guest visitors to a public website this information is generally limited to IP addresses, comments, or messages. Cogneti only discloses IP addresses under the same circumstances that it uses and discloses other Personally Identifiable Information Data information as described below.</p>
            <h3>System Performance Information</h3>
            <p>Allows Cogneti to monitor the performance of its systems when in use. This information is of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Such information may include number of page visits each day or the average test score of program participants. This information does NOT personally identify an individual. Cogneti’s purpose in collecting such information is to better understand how Cogneti’s visitors use its website. From time to time, Cogneti may release non-Personally Identifiable Information Data information in the aggregate, e.g., by publishing a report on trends in the usage of its website.</p>

            <div class="block-header" id="term3">
              <h2><span class="title">Gathering of Personally-Identifying Information</span></h2>
            </div>
            <p>Certain visitors to Cogneti’s websites choose to interact with Cogneti in ways that require Cogneti to gather Personally Identifiable Information Data. The amount and type of such information depends on the nature of the interaction. For example, we ask visitors who sign up to provide a username and email address. Those who engage in transactions with Cogneti – by purchasing licenses or services, for example – are asked to provide additional information, including as necessary the personal and financial information required to process those transactions. In each case, Cogneti collects such information only insofar as is necessary or appropriate to fulfill the purpose of the interaction with Cogneti.</p>
            <p>Cogneti does not disclose Personally Identifiable Information Data other than as described below. And visitors can always refuse to supply Personally Identifiable Information Data information, with the caveat that it may prevent them from engaging in related activities.</p>


            <div class="block-header" id="term4">
              <h2><span class="title">Aggregated Statistics</span></h2>
            </div>
            <p>Cogneti may collect statistics about the behavior of visitors to its websites. Cogneti may display this information publicly or provide it to others. However, Cogneti does not disclose Personally Identifiable Information Data information other than as described below.</p>


            <div class="block-header" id="term5">
              <h2><span class="title">Protection of Certain Personally-Identifying Information</span></h2>
            </div>
            <p>Cogneti discloses Personally Identifiable Information Data only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Cogneti’s behalf or to provide services available at Cogneti’s websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Cogneti’s websites, you consent to the transfer of such information to them. Cogneti will not sell or provide access to Personally Identifiable Information Data to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Cogneti discloses Personally Identifiable Information Data only in response to a subpoena, court order or other governmental request, or when Cogneti believes in good faith that disclosure is reasonably necessary to protect the property or rights of Cogneti, third parties or the public at large. If you are a registered user of a Cogneti website and have supplied your email address, Cogneti may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what’s going on with Cogneti and our products. We also may use our various client applications to communicate this type of information, so we expect to keep this type of email to a minimum. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to use PIID to help us clarify or respond to your request or to help us support other users. Cogneti takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of Personally Identifiable Information Data.</p>

            <div class="block-header" id="term6">
              <h2><span class="title">Cookies</span></h2>
            </div>
            <p>A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. Cogneti uses cookies to help Cogneti identify and track visitors, their usage of Cogneti website, and their website access preferences. Cogneti visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Cogneti’s websites, with the drawback that certain features of Cogneti’s websites may not function properly without the aid of cookies.</p>

            <div class="block-header" id="term7">
              <h2><span class="title">Business Transfers</span></h2>
            </div>
            <p>If Cogneti, or substantially all of its assets, were acquired, or in the event that Cogneti goes out of business or enters bankruptcy, user information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of Cogneti may continue to use your personal information as set forth in this policy.</p>

            <div class="block-header" id="term8">
              <h2><span class="title">Advertisements (Ads)</span></h2>
            </div>
            <p>Ads appearing on any of our websites or players may be delivered to users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This Privacy Policy covers the use of cookies by Cogneti and does not cover the use of cookies by any advertisers.</p>


            <div class="block-header" id="term9">
              <h2><span class="title">Privacy Policy Changes</span></h2>
            </div>
            <p>Although most changes are likely to be minor, Cogneti may change its Privacy Policy from time to time, and in Cogneti’s sole discretion. Cogneti encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.</p>

            <div class="block-header" id="term10">
              <h2><span class="title">Change log</span></h2>
            </div>
            <ul>
              <li>October 28, 2017: Created the privacy policy using original material available under Creative Commons ShareAlike 2.5 license (CC BY-SA 2.5)</li>
              <li>May 14, 2024: Updated for readability and use of common industry terms.</li>
              <li>March 22, 2025: Updated for readability and use of common industry terms.</li>
            </ul>
          </div>

          <v-btn
            v-if="scrolled > 200"
            fixed
            dark
            small
            fab
            bottom
            right
            color="blue"
            @click.prevent="$vuetify.goTo('#link-index')"
          >
            <span class="notranslate"><v-icon>arrow_upward</v-icon></span>
          </v-btn>

        </div>
      </v-flex>
    </scroll-data>

  </v-layout>



</template>

<script>
  import ScrollData from '../../ScrollData'
  import Header from '../../layouts/Header'
  export default {
    name: 'PrivacyPolicy',
    components: {Header, ScrollData},
    props: {
      msg: String
    },
    data () {
      return {
        scrolled: 0
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        this.scrolled = window.scrollY
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/PrivacyPolicy.vue